import { DefaultRootState } from 'react-redux';

import { ResumeExportTypeDto } from 'src/models/applicant/resume/download/store';

export const selectResumeExportTypes = ({ resumeExportTypes }: DefaultRootState): ResumeExportTypeDto[] =>
    resumeExportTypes;
